var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNastavno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18125_12136",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18125_12136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.6155 21C4.15517 21 3.77083 20.8458 3.4625 20.5375C3.15417 20.2292 3 19.8448 3 19.3845V9.6155C3 9.15517 3.15417 8.77083 3.4625 8.4625C3.77083 8.15417 4.15517 8 4.6155 8H10V4C10 3.725 10.0979 3.48958 10.2938 3.29375C10.4896 3.09792 10.725 3 11 3H13C13.275 3 13.5104 3.09792 13.7063 3.29375C13.9021 3.48958 14 3.725 14 4V8H19.3845C19.8448 8 20.2292 8.15417 20.5375 8.4625C20.8458 8.77083 21 9.15517 21 9.6155V19.3845C21 19.8448 20.8458 20.2292 20.5375 20.5375C20.2292 20.8458 19.8448 21 19.3845 21H4.6155ZM6.30775 17.423H11.6923V17.2807C11.6923 17.0539 11.63 16.8438 11.5055 16.6503C11.381 16.4568 11.2073 16.3067 10.9845 16.2C10.6638 16.0628 10.3392 15.9599 10.0105 15.8913C9.68167 15.8228 9.34483 15.7885 9 15.7885C8.65517 15.7885 8.31833 15.8228 7.9895 15.8913C7.66083 15.9599 7.33617 16.0628 7.0155 16.2C6.79267 16.3067 6.619 16.4568 6.4945 16.6503C6.37 16.8438 6.30775 17.0539 6.30775 17.2807V17.423ZM14 15.8845H18V15H14V15.8845ZM8.9955 15C9.3255 15 9.60742 14.8845 9.84125 14.6535C10.0753 14.4227 10.1923 14.1423 10.1923 13.8123C10.1923 13.4823 10.0767 13.2003 9.84575 12.9663C9.61492 12.7324 9.3345 12.6155 9.0045 12.6155C8.6745 12.6155 8.39258 12.7309 8.15875 12.9618C7.92475 13.1927 7.80775 13.4733 7.80775 13.8033C7.80775 14.1331 7.92325 14.415 8.15425 14.649C8.38508 14.883 8.6655 15 8.9955 15ZM14 13.5H18V12.6155H14V13.5ZM11 9.76925H13V4H11V9.76925Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNastavno);
export default __webpack_public_path__ + "static/media/nastavno.3d5d292f29fb1a551ef73e8044de720c.svg";
export { ForwardRef as ReactComponent };